import * as React from 'react';
const SVGComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 15"
    {...props}
  >
    <rect width="14" height="14" y="0.5" fill="#686D7E" rx="7"></rect>
    <path
      stroke="#F5F5F5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.167"
      d="M10.111 5.172 5.834 9.45 3.889 7.505"
    ></path>
  </svg>
);
export default SVGComponent;
